import React from 'react'

// Define the type for our API context value
type ApiContextType = string | null;

// Create a typed context with an initial null value
export const ApiContext = React.createContext<ApiContextType>(null)

/**
 * Hook to access the API URL from context
 * @returns {string} The API URL
 */
export const useApi = (): string => {
  const context = React.useContext(ApiContext)
  if (context === undefined || context === null) {
    throw new Error('API must be used within a ApiContextProvider')
  }
  return context
}
